import { defineComponent } from 'vue'
import { useDialog } from 'primevue/usedialog'
import Button from 'primevue/button'
import { navigateToReviewSite } from '@/utils/rating'
import imgUrl from '/img/logo.png'
// @ts-expect-error import path to avoid circular dependency issues
import store from '@/store'

export async function openReviewDialog(opts: {
  dialog: ReturnType<typeof useDialog>,
  onRemindLater?: () => void,
  onReviewed?: () => void,
  onDecline?: () => void
}): Promise<void> {
  const { dialog, onRemindLater, onReviewed, onDecline } = opts || {}
  const giftCardAmount = store.state.timezone === 'Asia/Manila' ? 'USD $15' : 'USD $25'

  let closed = false

  function close(type: 'remind' | 'reviewed' | 'decline') {
    if (closed) return
    closed = true
    dialogRef.close()
    if (type === 'remind' && onRemindLater) onRemindLater()
    else if (type === 'reviewed' && onReviewed) onReviewed()
    else if (type === 'decline' && onDecline) onDecline()
  }

  const DialogContent = defineComponent({
    setup (_props, _context) {
      return () => (
        <div class="tw:w-full tw:p-1 tw:pt-0" style="color: var(--primary-dark-blue);">
          <div class="header tw:flex tw:justify-between tw:w-full tw:items-center">
            <Button
              label="Remind me Later"
              link
              size="small"
              class="tw:p-1"
              pt={ { label: '!tw:text-2xs' } }
              onClick={() => close('remind')}
            />
            <font-awesome-icon
              icon="xmark"
              class="tw:text-xs tw:p-2"
              onClick={() => close('decline')}
            />
          </div>
          <div class="body tw:flex tw:flex-col tw:w-full tw:items-center tw:pb-2">
            <img src={imgUrl} class="tw:w-36" />
            <div class="tw:text-lg tw:font-extrabold tw:m-2">
              We value your feedback!
            </div>
            <Button
              type="button"
              size="small"
              label="Leave a Review"
              class='tw:w-40 tw:py-1 tw:rounded-xs'
              pt={ { label: 'tw:font-extrabold !tw:text-sm' } }
              onClick={() => {
                navigateToReviewSite()
                close('reviewed')
              }}
            />
            <div class="tw:font-bold tw:mt-3">
              { `Receive a ${giftCardAmount} gift card reward.` }
            </div>
            <div class="tw:text-2xs tw:italic tw:mt-2">
              Take a screenshot of your review and email it to
            </div>
            <div class="tw:text-2xs tw:italic">
              <a href="mailto:marketing@fareclock.com">marketing@fareclock.com</a> so we can process your gift card!
            </div>
          </div>
        </div>
      )
    }
  })

  const dialogRef = dialog.open(DialogContent, {
    props: {
      style: {
        width: '350px'
      },
      pt: {
        root: 'tw:rounded-xs',
        header: 'tw:flex-row-reverse tw:px-2 tw:pt-1 tw:pb-0',
        pcCloseButton: { root: 'tw:w-4 tw:h-4', icon: { class: 'tw:w-3 tw:h-3' } },
        content: 'tw:p-0'
      },
      modal: true,
      dismissableMask: false,
      // show over feedback modal's z-index of 1103
      baseZIndex: 1104,
      showHeader: false
    }
  })
}
